import React from "react";
import { IconProps } from "../../components/Icon";

export default function Unsubscribe(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14"}
      height={height || "14"}
      viewBox="0 0 14 14"
    >
      <g id="Icon" transform="translate(-160.881 -73.943)">
        <path
          id="Path_10176"
          data-name="Path 10176"
          d="M7.25-13.75a7,7,0,0,0-7,7,7,7,0,0,0,7,7,7,7,0,0,0,7-7A7,7,0,0,0,7.25-13.75Zm3.432,8.837a.339.339,0,0,1,0,.48L9.565-3.318a.339.339,0,0,1-.48,0L7.25-5.169,5.413-3.318a.339.339,0,0,1-.48,0L3.818-4.435a.339.339,0,0,1,0-.48L5.669-6.75,3.818-8.587a.339.339,0,0,1,0-.48l1.118-1.118a.339.339,0,0,1,.48,0L7.25-8.331l1.837-1.852a.339.339,0,0,1,.48,0l1.118,1.118a.339.339,0,0,1,0,.48L8.831-6.75Z"
          transform="translate(160.631 87.693)"
          fill={color || "#111"}
        />
      </g>
    </svg>
  );
}
